import {on, findAllIn, findIn, closest} from '@elements/dom-utils';
import {onFind} from "@elements/init-modules-in-scope";
import asyncAppend from "@elements/async-append";
import axios from "axios";
import Modal from 'bootstrap/js/dist/modal';

export function init() {

    onFind('.js-edit-form-box', function (baseElement) {
        let modals = findAllIn('.js-edit-form-box__modal', baseElement);

        modals.map(function (modal) {
            let modalId = modal.getAttribute('id');
            on('shown.bs.modal', function () {
                let form = findIn('.js-edit-form-box__form', modal);

                let formTrigger = 'form-validation.submit';
                if (form.getAttribute('data-form-trigger')) {
                    formTrigger = form.getAttribute('data-form-trigger');
                }

                on(formTrigger, (evt) => {
                    loadContent(baseElement, form.getAttribute('data-action'), new FormData(form), form.getAttribute('method')).then(() => {
                        if (form.getAttribute('data-form-reload')) {
                            window.location.reload();
                        }
                    });
                    let modalInstance = Modal.getInstance('#' + modalId);
                    modalInstance.hide();
                }, form);
            }, modal);
        });
    });
}

function loadContent(baseElement, url, data, method) {
    let pendingRequest;

    console.log(baseElement);

    if (method === 'GET') {
        pendingRequest = axios({method: 'GET', url: url, params: data});
    } else {
        pendingRequest = axios({method: 'POST', url: url, data: data});
    }

    asyncAppend({
        target: findIn('.js-edit-form-box__result', baseElement),
        loading: findIn('.js-edit-form-box__loading', baseElement)
    }, pendingRequest.then((x) => x.data));

    return pendingRequest;
}
